import React from 'react';
import styled from 'styled-components';

import { useColor } from '../../../modules/contexts/Color/useColor';

interface PapelVinculosProps {
  value?: string;
}

const VinculoBadge = styled.div<{ bgColor: string; textColor: string }>`
  background-color: ${({ bgColor }) => bgColor};
  padding: 8px 4px;
  border-radius: 6px;
  /* font-size: 0.75rem; */
  text-align: center;
  font-weight: 500;
  color: ${({ textColor }) => textColor};
  white-space: nowrap;
`;

export const PAPEL_VINCULO_COR: Record<string, string> = {
  ADMIN: 'Azul-Atlântico',
};

export const PapelVinculosCell: React.FC<PapelVinculosProps> = ({ value }) => {
  const { getHexByNome } = useColor();

  if (!value) return null;

  const nomeCor = PAPEL_VINCULO_COR[value] || 'Amarelo-Sol';

  const bgColor = getHexByNome(nomeCor, '#dddddddd');

  const textColor = value === 'ADMIN' ? '#FFFFFF' : 'black';

  return (
    <VinculoBadge bgColor={bgColor} textColor={textColor}>
      {value}
    </VinculoBadge>
  );
};
